<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<div *ngIf="!loading" class="max-w-[624px] mx-auto mt-4">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()">
        

        <!-- Nome do Usuário -->
        <div class="border-b pb-4 mt-4">
            <label for="name" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                Nome do Usuário*
            </label>
            <input
                type="text"
                id="name"
                formControlName="name"
                placeholder="Insira o nome do usuário"
                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-puring-westetics-purple-800 block w-full p-2.5"
                [ngClass]="{'border-red-500': userForm.get('name')?.invalid && userForm.get('name')?.touched}"
            />
            <span class="text-red-600 text-sm" *ngIf="userForm.get('name')?.invalid && userForm.get('name')?.touched">
                Insira um nome de usuário válido.
            </span>
        </div>

        <!-- E-mail (desabilitado) -->
        <div class="border-b pb-4 mt-4">
            <label for="email" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                E-mail (não editável)
            </label>
            <input
                type="email"
                id="email"
                formControlName="email"
                placeholder="Insira o e-mail"
                class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
                [ngClass]="{'border-red-500': userForm.get('email')?.invalid && userForm.get('email')?.touched}"
            />
            <!-- Required error -->
            <span class="text-red-600 text-sm" *ngIf="userForm.get('email')?.errors?.['required'] && userForm.get('email')?.touched">
                O e-mail é obrigatório.
            </span>
            <!-- emailTld validator error (missing TLD like .com, .com.br) -->
            <span class="text-red-600 text-sm" *ngIf="userForm.get('email')?.errors?.['emailTld'] && userForm.get('email')?.touched">
                Insira um e-mail válido (ex: nome@dominio.com).
            </span>
            <!-- Inline API validation error for email (e.g. "Email já cadastrado.") -->
            <span class="text-red-600 text-sm mt-1 block" *ngIf="userForm.get('email')?.errors?.['api']">
                {{ userForm.get('email')?.errors?.['api'] }}
            </span>
        </div>

        <!-- Status -->
        <div class="border-b pb-4 mt-4">
            <p class="font-medium text-sm text-westetics-neutral-950">
                Status*
            </p>
            <div class="mt-3 flex gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="is_blocked"
                        value="false"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-puraccent-westetics-purple-800">Ativo</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="is_blocked"
                        value="true"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-puraccent-westetics-purple-800">Bloqueado</span>
                </label>
            </div>
        </div>

        <!-- Permissão -->
        <div *ngIf="hasToShowPermissionField" class="border-b pb-4 mt-4">
            <p class="font-medium text-sm text-westetics-neutral-950">
                Permissão*
            </p>
            <div class="mt-3 flex gap-4">
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="permission"
                        value="ATTENDANT"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-puraccent-westetics-purple-800">Atendente</span>
                </label>
                <label class="flex items-center gap-2 cursor-pointer">
                    <input
                        type="radio"
                        formControlName="permission"
                        value="ADMIN"
                        class="w-4 h-4 accent-westetics-purple-800"
                    />
                    <span class="text-sm font-normal text-westetics-puraccent-westetics-purple-800">Administrador</span>
                </label>
            </div>
            <span class="text-red-600 text-sm" *ngIf="userForm.get('permission')?.invalid && userForm.get('permission')?.touched">
                Selecione uma permissão.
            </span>

            <!-- Clínicas Vinculadas — oculto para ADMINs e quando clínica ativa não pertence a nenhum grupo -->
            <div class="mt-4" *ngIf="activeClinicHasGroup && userForm.get('permission')?.value !== 'ADMIN'">
                <p class="font-medium text-sm text-westetics-neutral-950">
                    Clínicas Vinculadas*
                </p>
                <p class="text-xs text-westetics-neutral-600 mt-1">
                    Selecione as clínicas que este usuário terá acesso.
                </p>
                <div class="relative mt-3">
                    <!-- Botão trigger -->
                    <button
                        type="button"
                        (click)="toggleClinicsDropdown()"
                        class="w-full flex items-center justify-between px-3 py-2.5 bg-gray-50 border border-gray-300 rounded-lg text-sm text-neutral-500 text-left"
                        [ngClass]="{'border-red-500': selectedClinicIds.length === 0 && userForm.touched}"
                    >
                        <span class="truncate" *ngIf="selectedClinicIds.length === 0">Selecione as clínicas</span>
                        <span class="truncate text-westetics-neutral-950" *ngIf="selectedClinicIds.length > 0">
                            {{ selectedClinicIds.length }} clínica(s) selecionada(s)
                        </span>
                        <svg
                            class="w-4 h-4 text-neutral-400 flex-shrink-0 transition-transform duration-200"
                            [class.rotate-180]="clinicsDropdownOpen"
                            viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M9.99956 10.879L13.7121 7.1665L14.7726 8.227L9.99956 13L5.22656 8.227L6.28706 7.1665L9.99956 10.879Z" fill="#99A0AE"/>
                        </svg>
                    </button>

                    <!-- Dropdown com checkboxes -->
                    <div *ngIf="clinicsDropdownOpen" class="absolute z-50 left-0 mt-1 w-full bg-white border border-gray-200 rounded-lg shadow-lg max-h-48 overflow-auto py-1">
                        <label
                            *ngFor="let clinic of availableClinics"
                            class="flex items-center gap-2 px-3 py-2 cursor-pointer hover:bg-gray-50 text-sm"
                        >
                            <input
                                type="checkbox"
                                [checked]="isClinicSelected(clinic.id)"
                                (change)="toggleClinicSelection(clinic.id)"
                                class="w-4 h-4 accent-westetics-purple-800 rounded"
                            />
                            <span class="truncate text-westetics-neutral-800">{{ clinic.name }}</span>
                            <span class="text-xs text-neutral-400 ml-auto">{{ clinic.cnpj }}</span>
                        </label>
                        <p *ngIf="availableClinics.length === 0" class="px-3 py-2 text-sm text-neutral-400">
                            Nenhuma clínica disponível.
                        </p>
                    </div>
                </div>

                <!-- Tags das clínicas selecionadas -->
                <div *ngIf="selectedClinicIds.length > 0" class="flex flex-wrap gap-2 mt-2">
                    <span
                        *ngFor="let clinic of selectedClinicsForDefault"
                        class="inline-flex items-center gap-1 px-2 py-1 bg-westetics-purple-50 text-westetics-purple-800 rounded-md text-xs"
                    >
                        {{ clinic.name }}
                        <button type="button" (click)="toggleClinicSelection(clinic.id)" class="ml-1 hover:text-red-500">
                            <svg class="w-3 h-3" viewBox="0 0 12 12" fill="currentColor"><path d="M9.35 3.35a.5.5 0 00-.7-.7L6 5.29 3.35 2.65a.5.5 0 10-.7.7L5.29 6 2.65 8.65a.5.5 0 10.7.7L6 6.71l2.65 2.64a.5.5 0 00.7-.7L6.71 6l2.64-2.65z"/></svg>
                        </button>
                    </span>
                </div>

                <span class="text-red-600 text-sm" *ngIf="selectedClinicIds.length === 0 && userForm.touched">
                    Selecione pelo menos uma clínica.
                </span>
            </div>
        </div>

        <!-- Resetar Senha -->
        <div class="border-b pb-4 mt-4">
            <div class="flex items-center justify-between">
                <div>
                    <p class="font-medium text-sm text-westetics-neutral-950">Resetar Senha</p>
                    <p class="text-xs text-westetics-neutral-600 mt-1">
                        Gera uma nova senha temporária. O usuário será obrigado a trocá-la no próximo login.
                    </p>
                </div>
                <button
                    type="button"
                    (click)="openResetPasswordModal()"
                    class="px-4 py-2 text-sm rounded-lg border border-red-400 text-red-600 hover:bg-red-50 whitespace-nowrap"
                >
                    Resetar Senha
                </button>
            </div>
        </div>

        <!-- Modal de Resetar Senha -->
        <div
            *ngIf="resetPasswordModalOpen"
            class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
            (click)="onResetModalBackdropClick($event)"
        >
            <div class="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6 relative">

                <!-- Estado 1: Confirmação -->
                <ng-container *ngIf="resetPasswordStep === 'confirm'">
                    <div class="flex items-center gap-3 mb-4">
                        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-red-100">
                            <svg class="w-5 h-5 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"/>
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-semibold text-westetics-neutral-950">Resetar senha</h3>
                            <p class="text-sm text-westetics-neutral-600">Essa ação não pode ser desfeita.</p>
                        </div>
                    </div>
                    <p class="text-sm text-westetics-neutral-700 mb-6">
                        Uma nova senha temporária será gerada e o usuário será obrigado a trocá-la no próximo login. Tem certeza que deseja continuar?
                    </p>
                    <div class="flex gap-3 justify-end">
                        <button
                            type="button"
                            (click)="closeResetPasswordModal()"
                            class="px-4 py-2 text-sm rounded-lg border border-gray-300 text-westetics-neutral-800 hover:bg-gray-50"
                        >
                            Cancelar
                        </button>
                        <button
                            type="button"
                            (click)="confirmResetPassword()"
                            class="px-4 py-2 text-sm rounded-lg bg-red-600 text-white hover:bg-red-700"
                        >
                            Sim, resetar senha
                        </button>
                    </div>
                </ng-container>

                <!-- Estado 2: Loading -->
                <ng-container *ngIf="resetPasswordStep === 'loading'">
                    <div class="flex flex-col items-center justify-center py-8">
                        <svg class="animate-spin h-10 w-10 text-westetics-purple-800 mb-4" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <p class="text-sm text-westetics-neutral-700">Resetando senha...</p>
                    </div>
                </ng-container>

                <!-- Estado 3: Sucesso -->
                <ng-container *ngIf="resetPasswordStep === 'success'">
                    <div class="flex items-center gap-3 mb-4">
                        <div class="flex items-center justify-center w-10 h-10 rounded-full bg-green-100">
                            <svg class="w-5 h-5 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                            </svg>
                        </div>
                        <div>
                            <h3 class="text-lg font-semibold text-westetics-neutral-950">Senha resetada</h3>
                            <p class="text-sm text-westetics-neutral-600">Copie a nova senha e envie ao usuário.</p>
                        </div>
                    </div>
                    <div class="flex gap-2 mb-6">
                        <input
                            type="text"
                            [value]="resetPasswordValue"
                            readonly
                            class="bg-gray-50 border border-gray-300 text-neutral-700 text-sm rounded-lg outline-none block w-full p-2.5 font-mono tracking-wider"
                        />
                        <button
                            type="button"
                            (click)="copyResetPassword()"
                            class="px-4 py-2.5 text-sm rounded-lg border border-westetics-purple-800 text-westetics-purple-800 hover:bg-westetics-purple-50 whitespace-nowrap flex items-center gap-1.5"
                        >
                            <svg *ngIf="!resetPasswordCopied" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"/>
                            </svg>
                            <svg *ngIf="resetPasswordCopied" class="w-4 h-4 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
                            </svg>
                            {{ resetPasswordCopied ? 'Copiado!' : 'Copiar' }}
                        </button>
                    </div>
                    <div class="flex justify-end">
                        <button
                            type="button"
                            (click)="closeResetPasswordModal()"
                            class="px-4 py-2 text-sm rounded-lg bg-westetics-purple-800 text-white hover:bg-westetics-purple-900"
                        >
                            Fechar
                        </button>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Botões (responsivo: empilha em mobile/tablet, centralizados em desktop) -->
        <div class="flex flex-col md:flex-row md:justify-center items-center gap-3 my-6">
            <button
                type="button"
                (click)="onCancel()"
                class="w-full md:w-44 px-4 py-2 md:py-[10px] text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg border text-sm md:text-base"
            >
                Cancelar
            </button>
            <button
                type="submit"
                class="w-full md:w-44 px-4 py-2 md:py-[10px] bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg text-sm md:text-base"
            >
                Salvar Alterações
            </button>
        </div>
    </form>
</div>
